import { useState } from 'react';
import { DayPicker, getDefaultClassNames } from 'react-day-picker';
import 'react-day-picker/style.css';

const Attendance = () => {
  const [value, onChange] = useState(new Date());
  const defaultClassNames = getDefaultClassNames();
  const classNames = {
    month_grid: `${defaultClassNames.month_grid}  flex-1`,
    day: `${defaultClassNames.day}  w-[30px] h-[30px] text-sm`,
    root: `${defaultClassNames.root}  z-0 `,
    months: `${defaultClassNames.months} gap-x-3 gap-y-5 justify-center md:justify-between items-center `,
    month: `${defaultClassNames.month}  `,
    month_caption: `${defaultClassNames.month_caption} h-auto`,
  };
  return (
    <section className="px-10 mt-[10vh] py-1 -z-10 mb-[5vh]">
      <div className="flex md:justify-between mb-8 md:flex-row flex-col">
        <p className="text-[#424242] md:text-xl text-lg font-semibold font-['Inter']">
          Your Child's Attendance Average is
          <span className="text-[#6e00dd] text-[22.80px] font-semibold font-['Inter']">
            {' 90% '}
          </span>
          this year
        </p>

        <div className="flex gap-2.5 flex-col md:flex-row">
          <div className="flex gap-2.5 mb-5 md:mb-0">
            <div className="flex items-center gap-1">
              <div className="w-[17px] h-[17px] bg-[#6e00dd] rounded-full" />
              <p className="justify-start text-[#4d4d4d] text-[10px] font-medium font-['Inter']">
                Perfect
              </p>
            </div>
            <div className="flex items-center gap-1">
              <div className="w-[17px] h-[17px] bg-[#6e00dd] rounded-full opacity-70" />
              <p className="justify-start text-[#4d4d4d] text-[10px] font-medium font-['Inter']">
                Fair
              </p>
            </div>
            <div className="flex items-center gap-1">
              <div className="w-[17px] h-[17px] bg-[#6e00dd] rounded-full opacity-40" />
              <p className="justify-start text-[#4d4d4d] text-[10px] font-medium font-['Inter']">
                Poor
              </p>
            </div>
            <div className="flex items-center gap-1">
              <div className="w-[17px] h-[17px] bg-[#e93737] rounded-full" />
              <p className="justify-start text-[#4d4d4d] text-[10px] font-medium font-['Inter']">
                Absent
              </p>
            </div>
          </div>
          <button className="flex items-center justify-center bg-[#8147e7] rounded-xl text-center  text-white text-[10px] font-normal font-['Inter'] leading-3 py-2 px-4">
            +All time
          </button>
        </div>
      </div>
      <p className="font-medium">2025</p>
      <div>
        <DayPicker
          numberOfMonths={12}
          selected={value}
          onSelect={onChange}
          defaultMonth={new Date(2025, 0)}
          animate
          pagedNavigation
          startMonth={new Date(2025, 0)}
          classNames={classNames}
          showOutsideDays
          fixedWeeks
        />
      </div>
    </section>
  );
};

export default Attendance;
